export default "__VITE_ASSET__9c330d63__"